import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ServicePage = lazy(() => import('../pages/service/page'));
const ProfilePage = lazy(() => import('../pages/profile/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const CompanyPage = lazy(() => import('../pages/company/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const LegalPage = lazy(() => import('../pages/legal/page'));
const SalonPage = lazy(() => import('../pages/salon/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/service',
    element: <ServicePage />,
  },
  {
    path: '/profile',
    element: <ProfilePage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/company',
    element: <CompanyPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '/legal',
    element: <LegalPage />,
  },
  {
    path: '/salon',
    element: <SalonPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;